jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

  
        const elementsPrev = document.querySelectorAll('button.flickityt4s-button.flickityt4s-prev-next-button.previous .flickityt4s-button-icon');
        const elementsNext = document.querySelectorAll('button.flickityt4s-button.flickityt4s-prev-next-button.next .flickityt4s-button-icon');
    
        elementsPrev.forEach(element => {
            const newImage = document.createElement('img');
            newImage.src = 'https://cdn.shopify.com/s/files/1/0901/4132/7635/files/flecha-correcta.png?v=1726593789';
            newImage.style.width = '20px';
            newImage.style.transform = 'scaleX(-1)';
            newImage.classList.add('new-image-icon');
            element.replaceWith(newImage);
        });

          elementsNext.forEach(element => {
            const newImage = document.createElement('img');
            newImage.src = 'https://cdn.shopify.com/s/files/1/0901/4132/7635/files/flecha-correcta.png?v=1726593789';
            newImage.style.width = '20px';
            newImage.classList.add('new-image-icon');
            element.replaceWith(newImage);
        });
  
});

// === OPTIMIZACIÓN Y CARGA CONDICIONAL DE LIBRERÍAS ===
// Lazy load Flickity solo si hay carouseles en la página
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.flickityt4s')) {
        if (typeof window.Flickityt4s === 'undefined') {
            var flickityScript = document.createElement('script');
            flickityScript.src = 'https://cdn.jsdelivr.net/npm/flickity@2/dist/flickity.pkgd.min.js';
            flickityScript.onload = function() {
                if (window.T4SThemeSP && typeof T4SThemeSP.initCarousel === 'function') {
                    T4SThemeSP.initCarousel();
                }
            };
            document.head.appendChild(flickityScript);
        } else {
            if (window.T4SThemeSP && typeof T4SThemeSP.initCarousel === 'function') {
                T4SThemeSP.initCarousel();
            }
        }
    }

    // Lazy load Isotope solo si hay grids filtrables en la página
    if (document.querySelector('.isotopet4s')) {
        if (typeof window.Isotope === 'undefined') {
            var isotopeScript = document.createElement('script');
            isotopeScript.src = 'https://cdn.jsdelivr.net/npm/isotope-layout@3/dist/isotope.pkgd.min.js';
            isotopeScript.onload = function() {
                if (window.T4SThemeSP && T4SThemeSP.Isotopet4s && typeof T4SThemeSP.Isotopet4s.initEach === 'function') {
                    T4SThemeSP.Isotopet4s.initEach();
                }
            };
            document.head.appendChild(isotopeScript);
        } else {
            if (window.T4SThemeSP && T4SThemeSP.Isotopet4s && typeof T4SThemeSP.Isotopet4s.initEach === 'function') {
                T4SThemeSP.Isotopet4s.initEach();
            }
        }
    }
});

// === LAZY LOADING PARA PLUGINS ADICIONALES ===
document.addEventListener('DOMContentLoaded', function() {
    // Magnific Popup (popups de imágenes)
    if (document.querySelector('.mfp-popup, .popup-link, .mfp-image')) {
        if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.magnificPopup === 'undefined') {
            var magnificScript = document.createElement('script');
            magnificScript.src = 'https://cdn.jsdelivr.net/npm/magnific-popup@1.1.0/dist/jquery.magnific-popup.min.js';
            magnificScript.onload = function() {
                // Inicialización segura (ajusta el selector según tu HTML)
                jQuery('.mfp-popup, .popup-link, .mfp-image').magnificPopup({
                    type: 'image',
                    gallery: { enabled: true }
                });
            };
            document.head.appendChild(magnificScript);
        }
    }

    // Drift Zoom (zoom de producto)
    if (document.querySelector('.drift-zoom, .js-zoom, .product-zoom')) {
        if (typeof window.Drift === 'undefined') {
            var driftScript = document.createElement('script');
            driftScript.src = 'https://cdn.jsdelivr.net/npm/drift-zoom@1.4.1/dist/Drift.min.js';
            driftScript.onload = function() {
                // Inicialización segura (ajusta el selector según tu HTML)
                var images = document.querySelectorAll('.drift-zoom, .js-zoom, .product-zoom');
                images.forEach(function(img) {
                    new Drift(img, { paneContainer: img.parentElement });
                });
            };
            document.head.appendChild(driftScript);
        }
    }

    // Ejemplo para otro slider (puedes agregar más patrones aquí)
    // if (document.querySelector('.otro-slider')) {
    //     // Lazy load e inicializa el slider solo si existe
    // }
});

// === FIN OPTIMIZACIÓN ===
// Documenta aquí cualquier sobrescritura o mejora adicional





